/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Redirectnotallowederror3Inputs */

const en_redirectnotallowederror3 = /** @type {(inputs: Redirectnotallowederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This redirect is not allowed. Please reload the page and try again.`)
};

const de_redirectnotallowederror3 = /** @type {(inputs: Redirectnotallowederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Weiterleitung ist nicht erlaubt. Bitte lade die Seite neu und versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "This redirect is not allowed. Please reload the page and try again." |
*
* @param {Redirectnotallowederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const redirectnotallowederror3 = /** @type {((inputs?: Redirectnotallowederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Redirectnotallowederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_redirectnotallowederror3(inputs)
	return de_redirectnotallowederror3(inputs)
});
export { redirectnotallowederror3 as "redirectNotAllowedError" }